/**
 * 判断输入值是否为有限数字。
 * @param value 输入值。
 * @returns 当值为有限数字时返回 true。
 */
export function isFiniteNullableNumber(value: number | null | undefined): value is number {
    return value != null && Number.isFinite(value);
}
